<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="netFlowProviders"
      :items="netFlowProviders"
      :fields="netFlowProvidersFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal :editItem="selectedNetFlowProviders"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      selectedNetFlowProviders: null,
      netFlowProvidersFields: [
        {key: 'provider_id', label: 'ID', sortable: true},
        {key: 'collector_id', label: this.$i18n.t('Traffic collector'), sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'comments', label: this.$i18n.t('Comments'), sortable: true},
        {key: 'ip_address', label: 'IP', sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedNetFlowProviders = {
        provider_id: 0,
        collector_id: 0,
        name: '',
        comments: '',
        address: ''
      }
      this.$root.$emit('bv::show::modal', 'modalEditNetFlowProvidersSetting', '#btnShow')
    },
    editItem (item) {
      this.selectedNetFlowProviders = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditNetFlowProvidersSetting', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "NetFlow providers"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_NETFLOW_PROVIDERS', item.provider_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_NETFLOW_PROVIDERS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    netFlowProviders () {
      return this.$store.getters['Settings/NETFLOW_PROVIDERS']
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_NETFLOW_PROVIDERS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/inventory/netFlowProviders/main.vue